import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import OldAddSignatoryPage from './OldAddSignatoryPage';
import { ROUTE_OLD_SIGNATORIES_PAGE } from '../../utils/constants';
import { addOldSignatories } from '../../infrastructure/oldSignatories';

class OldAddSignatorySection extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    this.props.history.push(ROUTE_OLD_SIGNATORIES_PAGE);
  }

  render() {
    const { bankId, brandId, offer, addOldSignatories } = this.props;

    return (
      <OldAddSignatoryPage
        brandId={brandId}
        bankId={bankId}
        offer={offer}
        saveOldAddSignatoryForm={addOldSignatories}
        getBusinessData=""
        backClick={this.businessBack}
      />
    );
  }
}

OldAddSignatorySection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveOldAddSignatoryForm: PropTypes.func.isRequired
};

const actionCreators = {
  addOldSignatories
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OldAddSignatorySection);
